<div style="position: relative; height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
    <div style="position: absolute; top: 0; width: 100%; height:100%">
    </div>
    <div style="z-index: 1;">
      <lib-check-mark></lib-check-mark>
      <div>
        <h3 style="text-align: center;">
            Please check your email to begin reset process.
        </h3>
      </div>
    </div>
  
  </div>
